import axios from "axios";
import dayjs from "dayjs";
// import events from "../data/response/events.json";

import config from "../../../config";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

export async function fetchEvents() {
  const displayMessage = (d) => {
    if (!d) return;
    const type_of_event = d.type_of_event.name ? d.type_of_event.name : "";
    const category = d.category.name ? d.category.name : "";
    const subcategory = d.subcategory ? d.subcategory : "";
    const sourceName = d.source
      ? `Πηγή: (${d.source.id === 3 ? "Χρήστης" : d.source.name})`
      : "";
    const date = d.updated_at
      ? dayjs(d.updated_at).format("DD/MM/YYYY HH:mm")
      : "";

    const message = `<div>
      <strong>${category}</strong>
      <p>${subcategory}</p>      
      <p>${type_of_event}</p>     
      <p>${sourceName}</p>
      <p>${date}</p>
    </div>`;

    return message;
  };

  const getEventIcon = (categoryID) => {
    switch (categoryID) {
      case 1:
        return "roadClosure";
      case 2:
        return "laneClosure";
      case 3:
        return "roadworks";
      case 4:
        return "tempTraffic";
      case 5:
        return "bridgeClosure";
      case 6:
        return "incident";
      case 7:
        return "adverseDriving";
      case 8:
        return "weather";
      case 9:
        return "accident";
      case 10:
        return "jam";
      default:
        return "roadClosure";
    }
  };

  try {
    const response = await axios.get(`${API_URL}/events`, {
      headers: {
        "X-API-Key": API_TOKEN,
        "Content-Type": "application/json",
      },
    });

    // console.log("response", response.data);

    const features = response.data.map((data) => ({
      id: data.id,
      type: "Feature",
      properties: {
        type_of_event: data.type_of_event.name,
        category: data.category.name,
        valid_from: data.valid_from
          ? dayjs(data.valid_from).format("DD/MM/YYYY HH:mm")
          : "",
        valid_until: data.valid_until
          ? dayjs(data.valid_until).format("DD/MM/YYYY HH:mm")
          : "",
        icon: getEventIcon(data.category.id),
        displayMessage: displayMessage(data),
        source: data.source,
        check_status: data.check_status,
      },
      geometry: {
        type: "Point",
        coordinates: Array.isArray(data.geometry?.coordinates?.[0])
          ? data.geometry.coordinates[0] // flatten if wrapped
          : data.geometry.coordinates,
      },
    }));

    return {
      data: {
        type: "FeatureCollection",
        features,
      },
      error: null,
    };
  } catch (error) {
    console.error("Error fetching form fields:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
}
